import React from 'react';

interface InlineTimePickerProps {
  hour: number; // 0-23
  minute: number; // 0-59
  onChange: (hour: number, minute: number) => void;
  minuteStep?: number; // default 5
}

const InlineTimePicker: React.FC<InlineTimePickerProps> = ({ hour, minute, onChange, minuteStep = 5 }) => {
  const hourOptions = Array.from({ length: 24 }, (_, i) => i);
  const minuteOptions = Array.from({ length: Math.floor(60 / minuteStep) }, (_, i) => i * minuteStep);
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return (
    <div className="flex flex-col gap-3">
      {/* Presets */}
      <div>
        <div className="text-xs font-medium text-gray-600 mb-1">Quick presets</div>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            className="px-3 py-1.5 rounded border text-xs hover:bg-gray-50"
            onClick={() => onChange(9, 0)}
          >09:00</button>
          <button
            type="button"
            className="px-3 py-1.5 rounded border text-xs hover:bg-gray-50"
            onClick={() => onChange(12, 0)}
          >12:00</button>
          <button
            type="button"
            className="px-3 py-1.5 rounded border text-xs hover:bg-gray-50"
            onClick={() => onChange(17, 0)}
          >17:00</button>
        </div>
      </div>

      {/* Selected summary */}
      <div className="text-sm text-gray-700">
        Selected time: {String(hour).padStart(2, '0')}:{String(minute).padStart(2, '0')}
      </div>

      {/* Time selectors - larger UI */}
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-xs text-gray-600 mb-1">Hour</label>
          <select
            value={hour}
            onChange={(e) => onChange(parseInt(e.target.value, 10), minute)}
            className="w-full border rounded-md px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-whatsapp-green"
          >
            {hourOptions.map((h) => (
              <option key={h} value={h}>{String(h).padStart(2, '0')}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-xs text-gray-600 mb-1">Minute</label>
          <select
            value={minute}
            onChange={(e) => onChange(hour, parseInt(e.target.value, 10))}
            className="w-full border rounded-md px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-whatsapp-green"
          >
            {minuteOptions.map((m) => (
              <option key={m} value={m}>{String(m).padStart(2, '0')}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="text-xs text-gray-600">Timezone: {tz}</div>
    </div>
  );
};

export default InlineTimePicker;
